import { render, staticRenderFns } from "./DefectDataFormatter.vue?vue&type=template&id=915045e4&functional=true"
import script from "./DefectDataFormatter.vue?vue&type=script&lang=js"
export * from "./DefectDataFormatter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports